import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { Background } from 'layout';
import { Button, InputOtp, Loader } from 'ui';
import styles from './otpForm.module.css';
import { Box, Typography } from '@material-ui/core';
import { ReactComponent as Clock } from 'assets/images/at_clock.svg';
import cn from 'classnames';
import useOTPForm from './useOTPForm';

const OTPForm = ({ token, metadata, setVerified }) => {
    const { formik, loading, canRetry, formattedSeconds, resend } = useOTPForm({
        token,
        setVerified,
    });

    const handleOtpChange = useCallback(
        (otp) => {
            formik.setFieldValue('code', otp);
        },
        [formik]
    );

    return (
        <Background className={styles.otpCardWrapper} wrapper={styles.wrapper}>
            <Card.Header as="h5" className={styles.cardHeader}>
                Enter One-Time Passcode
            </Card.Header>
            {loading ? (
                <Card.Body className={styles.body}>
                    <Loader />
                </Card.Body>
            ) : (
                <Form onSubmit={formik.handleSubmit} className={styles.otpForm}>
                    <Card.Body className={styles.cardbody}>
                        <Box>
                            <Typography className={styles.description}>
                                We have sent a One-Time Passcode to verify the {metadata?.email}{' '}
                                email.
                            </Typography>
                            <Typography className={styles.label}>
                                Please enter the code to proceed.
                            </Typography>
                        </Box>

                        <InputOtp
                            value={formik.values.code}
                            handleChange={handleOtpChange}
                            name="name"
                            error={formik.touched.code && Boolean(formik.errors.code)}
                            helperText={formik.touched.code && formik.errors.code}
                        />
                        <Box className={styles.timer}>
                            <Clock className={styles.clockIcon} />
                            <Typography
                                component="p"
                                className={cn(styles.timerText, { [styles.dark]: canRetry })}
                            >
                                Didn’t receive the OTP?{' '}
                                {canRetry ? (
                                    <button onClick={resend} className={styles.retryBtn}>
                                        Resend
                                    </button>
                                ) : (
                                    <>Retry in 00:{formattedSeconds} seconds.</>
                                )}
                            </Typography>
                        </Box>
                    </Card.Body>
                    <Card.Footer className={styles.cardFooter}>
                        <Button className={styles.footerBtn} variant="primary" type="submit">
                            Confirm
                        </Button>
                    </Card.Footer>
                </Form>
            )}
        </Background>
    );
};

OTPForm.propTypes = {
    token: PropTypes.string,
    metadata: PropTypes.object,
    setVerified: PropTypes.func.isRequired,
};

export default OTPForm;
